module.exports = __webpack_public_path__ + "img/thermometer.fe53670d.svg";